/**
 * @generated SignedSource<<68861525580ddb604bf0ffc6257dbca8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailCondition_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedDetailCondition_item";
};
export type PdpSharedDetailCondition_item$key = {
  readonly " $data"?: PdpSharedDetailCondition_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailCondition_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailCondition_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "1d1fedc2b85af30e48bb0aa7d9c7c84a";

export default node;
